module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resource-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "container-responsive"
  }, [_c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Set the Tone of Your Life")]), _vm._v(" "), _vm._l((_vm.getAllSetToneResources), function(fa) {
    return (_vm.getAllFeaturedArticles) ? _c('div', [(fa.articleHeader) ? _c('h4', {
      style: ({
        'borderBottom': '2px solid ' + _vm.getCorpHeaderColor + ' !important'
      })
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "title": fa.articleHeader,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fa.articleHeader))])]) : _vm._e(), _vm._v(" "), (fa.articleHeader) ? _c('div', {
      staticClass: "row"
    }, [(fa.imageUrl) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_c('img', {
      attrs: {
        "src": fa.imageUrl,
        "alt": fa.articleHeader,
        "title": fa.articleHeader
      }
    })]) : _vm._e(), _vm._v(" "), (fa.description) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(fa.description)), _c('br'), _c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "target": "_blank"
      }
    }, [_vm._v("(more)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Featured Articles")]), _vm._v(" "), _vm._l((_vm.getAllFeaturedArticles), function(fa) {
    return (_vm.getAllSetToneResources) ? _c('div', [(fa.articleHeader) ? _c('h4', {
      style: ({
        'borderBottom': '2px solid ' + _vm.getCorpHeaderColor + ' !important'
      })
    }, [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "title": fa.articleHeader,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(fa.articleHeader))])]) : _vm._e(), _vm._v(" "), (fa.articleHeader) ? _c('div', {
      staticClass: "row"
    }, [(fa.imageUrl) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_c('img', {
      attrs: {
        "src": fa.imageUrl,
        "alt": fa.articleHeader,
        "title": fa.articleHeader
      }
    })]) : _vm._e(), _vm._v(" "), (fa.description) ? _c('div', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(fa.description)), _c('br'), _c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "href": fa.articleUrl,
        "target": "_blank"
      }
    }, [_vm._v("(more)")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Resources")]), _vm._v(" "), _c('div', {
    staticClass: "accordionholder"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true,
      "type": "default"
    }
  }, [_c('panel', [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory1_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory1_links), function(link) {
    return (_vm.resourceCategory1_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #2"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory2_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory2_links), function(link) {
    return (_vm.resourceCategory2_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #3"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory3_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory3_links), function(link) {
    return (_vm.resourceCategory3_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #4"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory4_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory4_links), function(link) {
    return (_vm.resourceCategory4_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #5"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory5_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory5_links), function(link) {
    return (_vm.resourceCategory5_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #6"
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.resourceCategory6_text))])]), _vm._v(" "), _vm._l((_vm.resourceCategory6_links), function(link) {
    return (_vm.resourceCategory6_links) ? _c('div', [_c('a', {
      style: ({
        color: _vm.getCorpHeadingColor
      }),
      attrs: {
        "target": "_blank",
        "href": link.url
      }
    }, [_vm._v(_vm._s(link.title))]), _c('br')]) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 text-left "
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.video_title))]), _vm._v(" "), _c('div', {
    staticClass: "video-holder"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "id": "resourcesvideoplay",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo && _vm.video_code.indexOf('http') >= 0) ? _c('img', {
    attrs: {
      "src": _vm.video_code,
      "alt": _vm.video_title,
      "title": _vm.video_title
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.liveEvent) ? _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.liveEvent.start_date, 'str')))]) : _vm._e(), _vm._v(" "), (_vm.liveEvent) ? _c('small', [_vm._v(_vm._s(_vm.liveEvent.longDescription))]) : _vm._e(), _vm._v(" "), (_vm.liveEvent && !_vm.showJoin(_vm.liveEvent)) ? _c('div', {
    staticClass: "text-center smlbuttonholder"
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.liveEvent.title)
      }
    }
  }, [_vm._v("\n                        Add to Calendar\n                        "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.liveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.liveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.liveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.liveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [(_vm.liveEvent.type === '1') ? _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.liveEvent.eventId)))]) : _c('span', [_vm._v(_vm._s(_vm.buildEventLink(_vm.liveEvent.eventId)))])])]), _vm._v(" "), ((_vm.user && _vm.user.corporation && _vm.user.corporation.corpSharingPermissions && _vm.user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)) ? _c('button', {
    staticClass: "share-event",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: _vm.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCorporateImageShareModal
    }
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showJoin(_vm.liveEvent)) ? _c('button', {
    staticClass: "button btn btn-pink btn-primary pull-center",
    style: (_vm.styleObject),
    attrs: {
      "type": "button"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.updateHoverState(true)
      },
      "mouseleave": function($event) {
        return _vm.updateHoverState(false)
      },
      "click": function($event) {
        return _vm.joinEvent(_vm.liveEvent)
      }
    }
  }, [_c('i', {
    staticClass: "fa 2x fa-arrow-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Go to Event ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.firstAdvertisementBox) ? _c('div', {
    staticClass: "advertizmentbox"
  }, [(_vm.firstAdvertisementBox && _vm.firstAdvertisementBox.videoCode && _vm.firstAdvertisementBox.videoObject) ? _c('jwplayer', {
    attrs: {
      "id": "resourcesad1",
      "data": _vm.firstAdvertisementBox.videoObject
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (_vm.firstAdvertisementBox.imageUrl && !_vm.firstAdvertisementBox.videoCode) ? _c('img', {
    attrs: {
      "src": _vm.firstAdvertisementBox.imageUrl,
      "alt": _vm.firstAdvertisementBox.articleHeader,
      "title": _vm.firstAdvertisementBox.articleHeader
    }
  }) : _vm._e(), _vm._v(" "), (_vm.firstAdvertisementBox.articleHeader) ? _c('p', {
    staticStyle: {
      "padding": "20px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.firstAdvertisementBox.articleHeader)
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "id": "sFeatures"
    }
  }, [_vm._v("Site Features")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "accordionholder"
  }, [_c('accordion', {
    attrs: {
      "one-at-atime": true,
      "type": "default"
    }
  }, [_c('panel', {
    attrs: {
      "is-open": _vm.openPanel(_vm.siteFeatures1_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures1_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures1_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #2",
      "is-open": _vm.openPanel(_vm.siteFeatures2_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures2_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures2_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #3",
      "is-open": _vm.openPanel(_vm.siteFeatures3_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures3_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures3_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #4",
      "is-open": _vm.openPanel(_vm.siteFeatures4_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures4_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures4_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #5",
      "is-open": _vm.openPanel(_vm.siteFeatures5_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures5_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures5_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #6",
      "is-open": _vm.openPanel(_vm.siteFeatures6_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures6_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures6_desc) + "\n                            ")]), _vm._v(" "), _c('panel', {
    attrs: {
      "header": "Panel #7",
      "is-open": _vm.openPanel(_vm.siteFeatures7_text)
    }
  }, [_c('strong', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('u', [_vm._v(_vm._s(_vm.siteFeatures7_text))])]), _vm._v("\n                                " + _vm._s(_vm.siteFeatures7_desc) + "\n                            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('h3', {
    staticClass: "adboxheading",
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Sign Up For Our Newsletter")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "footer_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onEmailSignUp.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "formholder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subscriptionForm.email),
      expression: "subscriptionForm.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "title": "please enter a valid email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.subscriptionForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subscriptionForm, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.mediaColl), function(ad) {
    return _c('div', [(ad) ? _c('div', {
      staticClass: "advertizmentbox"
    }, [(ad && ad.videoCode && ad.videoObject) ? _c('jwplayer', {
      attrs: {
        "data": ad.videoObject
      }
    }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (ad.imageUrl && !ad.videoCode) ? _c('img', {
      attrs: {
        "src": ad.imageUrl,
        "alt": ad.articleHeader,
        "title": ad.articleHeader
      }
    }) : _vm._e(), _vm._v(" "), (ad.articleHeader) ? _c('p', {
      staticStyle: {
        "padding": "20px"
      },
      domProps: {
        "innerHTML": _vm._s(ad.articleHeader)
      }
    }) : _vm._e()], 1) : _vm._e()])
  }), _vm._v(" "), _c('h3', {
    staticClass: "adboxheading",
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Follow US")]), _vm._v(" "), _c('div', {
    staticClass: "socialblocks"
  }, [_c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.facebook.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://twitter.com/ToneNetworks",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.instagram.com/tonenetworks/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.linkedin.com/company/25037986/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    style: ({
      backgroundColor: _vm.getCorpHeadingColor
    }),
    attrs: {
      "href": "https://www.youtube.com/channel/UCarjWAb1SWrzKtoeNimOVJA/videos",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2)])]), _vm._v(" "), (_vm.showCorporateImageShare) ? _c('modal', {
    staticClass: "watchVideoModal sharesmallpink",
    attrs: {
      "effect": "zoom",
      "value": _vm.showCorporateImageShare
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor
    }),
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" Share with your Corporate Community Or Friends\n                "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": "CLOSE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareOption),
      expression: "shareOption"
    }],
    staticClass: "form-control strongselec",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shareOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Corporate"
    }
  }, [_vm._v("Share with Community")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Individual"
    }
  }, [_vm._v("Share with Colleagues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Friends"
    }
  }, [_vm._v("Share with Friends")])])]), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), (_vm.shareOption === 'Individual') ? _c('multiselect', {
    attrs: {
      "options": _vm.allCorps,
      "multiple": true,
      "taggable": true,
      "track-by": "userId",
      "custom-label": _vm.customLabel
    },
    model: {
      value: (_vm.selectedCorps),
      callback: function($$v) {
        _vm.selectedCorps = $$v
      },
      expression: "selectedCorps"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shareOption === 'Friends') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('multiselect', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "tag-placeholder": "Add this as new email address",
      "placeholder": "Search or add an email address",
      "label": "name",
      "track-by": "name",
      "options": _vm.emailList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.taggedEmails),
      callback: function($$v) {
        _vm.taggedEmails = $$v
      },
      expression: "taggedEmails"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "usernamenimg text-left"
  }, [_c('table', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.corporation && _vm.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : _vm.user.picture,
      "alt": "user"
    }
  }), _vm._v("   "), _c('b', [_vm._v(_vm._s(_vm.user.firstName.toLowerCase()))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.corporateShareMessage),
      expression: "corporateShareMessage"
    }],
    staticClass: "form-input form-control",
    attrs: {
      "type": "textarea",
      "placeholder": "Type your message"
    },
    domProps: {
      "value": (_vm.corporateShareMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.corporateShareMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row sharefb"
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-5"
  }, [_c('img', {
    attrs: {
      "src": _vm.shareEventSelected.img_url,
      "alt": _vm.shareEventSelected.title,
      "title": _vm.shareEventSelected.title
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-xs-7"
  }, [_c('h6', [_vm._v("WWW.TONENETWORKS.COM")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(((_vm.shareEventSelected.title) + " | TONE Networks")))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(((_vm.shareEventSelected.longDescription.substring(0,250)) + "...")))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row buttonsinpopup"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.cancelCorporateImageModal()
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-8"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-pink",
    style: ({
      backgroundColor: _vm.getCorpButtonColor,
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "disabled": (_vm.shareOption === 'Individual' && (_vm.selectedCorps === null || _vm.selectedCorps.length === 0 || _vm.shareInProcess)) || (_vm.shareOption === 'Friends' && (_vm.taggedEmails === null || _vm.taggedEmails.length === 0 || _vm.shareInProcess))
    },
    on: {
      "click": function($event) {
        return _vm.shareCorporateImage()
      }
    }
  }, [_vm._v("\n                            Share This Event\n                            "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.shareInProcess),
      callback: function($$v) {
        _vm.shareInProcess = $$v
      },
      expression: "shareInProcess"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-default showmobile"
  }, [_vm._v("\n                    You are sharing as " + _vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))) + "\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "yellowbtn"
  }, [_c('strong', [_vm._v("Sign Up")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46d191b4", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d191b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Resources.vue